import { render } from "./ModalCompletedThanksPointSend.vue?vue&type=template&id=143531f0&scoped=true&ts=true"
import script from "./ModalCompletedThanksPointSend.vue?vue&type=script&lang=ts"
export * from "./ModalCompletedThanksPointSend.vue?vue&type=script&lang=ts"

import "./ModalCompletedThanksPointSend.vue?vue&type=style&index=0&id=143531f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143531f0"]])

export default __exports__